import { track } from "@amplitude/analytics-react-native";
import toast from "src/swsh-native/toast";
import { amp } from "src/api/amplitude";

const toastUnsupportedFileTypes = ({
	numUnsupportedFiles,
	unsupportedFileTypes,
}: {
	numUnsupportedFiles: number;
	unsupportedFileTypes: string[];
}) => {
	if (numUnsupportedFiles === 0) return;
	track(amp.photo.attemptUploadUnsupportedFile, {
		numUnsupportedFiles,
		unsupportedFileTypes,
	});
	const fileTypes = unsupportedFileTypes.map((fileType) => (fileType ? fileType : "unknown"));
	toast({
		preset: "error",
		title: `${numUnsupportedFiles} unsupported file${numUnsupportedFiles === 1 ? "" : "s"}`,
		message:
			fileTypes.length > 0
				? `Could not process the following file types: ${fileTypes.join(", ")}`
				: "Please try again later",
	});
};
export default toastUnsupportedFileTypes;
